import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import VehiclePublic from "@/pages/VehiclePublic";
import StickerSheet from "@/pages/StickerSheet";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import Inventory from "@/pages/dashboard/Inventory";
import Specialists from "@/pages/dashboard/Specialists";
import Leads from "@/pages/dashboard/Leads";
import Settings from "@/pages/dashboard/Settings";
import Team from "@/pages/dashboard/Team";
import Platform from "@/pages/dashboard/Platform";
import Prospects from "@/pages/dashboard/Prospects";
import Signup from "@/pages/Signup";
import DealerPublic from "@/pages/DealerPublic";
import NewArrivals from "@/pages/NewArrivals";
import UpgradeOneTap from "@/pages/UpgradeOneTap";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import Legal from "@/pages/Legal";
import DemoStudio from "@/pages/DemoStudio";
import TryDemo from "@/pages/TryDemo";
import OnePager from "@/pages/OnePager";
import ScanRedirect from "@/pages/ScanRedirect";
import { isAdminHost } from "@/lib/brand";

function App() {
  const adminHost = isAdminHost();
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* www.vinconex.net = Vinconex staff console: its home page is the admin sign-in */}
            <Route path="/" element={adminHost ? <AdminLogin /> : <Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/d/:slug" element={<DealerPublic />} />
            <Route path="/d/:slug/new-arrivals" element={<NewArrivals />} />
            <Route path="/v/:vehicleId" element={<VehiclePublic />} />
            <Route path="/upgrade/specialist-match" element={<UpgradeOneTap />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/privacy" element={<Legal kind="privacy" />} />
            <Route path="/terms" element={<Legal kind="terms" />} />
            <Route path="/security" element={<Legal kind="security" />} />
            <Route path="/dpa" element={<Legal kind="dpa" />} />
            <Route path="/sticker/:vehicleId" element={<StickerSheet />} />
            <Route path="/demo" element={<DemoStudio />} />
            <Route path="/try" element={<TryDemo />} />
            <Route path="/try/:token" element={<TryDemo />} />
            <Route path="/onepager" element={<OnePager />} />
            <Route path="/s/:code" element={<ScanRedirect />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Inventory />} />
              <Route path="specialists" element={<Specialists />} />
              <Route path="leads" element={<Leads />} />
              <Route path="settings" element={<Settings />} />
              <Route path="team" element={<Team />} />
              <Route path="platform" element={<Platform />} />
              <Route path="prospects" element={<Prospects />} />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors theme="dark" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
